import { StyledFlex } from '@dreryk/react-components';

import { PreInterviewSettingsFormController } from './PreInterviewSettingsForm.types';
import { EnabledField } from './fields/EnabledField';
import { NotificationChannelField } from './fields/NotificationChannelField';
import { SendingModeField } from './fields/SendingModeField';

type PreInterviewSettingsFieldsProps = Readonly<Pick<PreInterviewSettingsFormController, 'register' | 'watch'>>;

export const PreInterviewSettingsFields = (props: PreInterviewSettingsFieldsProps): JSX.Element => {
   const enabled = props.watch('preInterviewEnabled');

   return (
      <StyledFlex direction={'column'} gap={'16px'}>
         <EnabledField register={props.register} />
         <NotificationChannelField register={props.register} disabled={!enabled} />
         <SendingModeField register={props.register} disabled={!enabled} />
      </StyledFlex>
   );
};
